/**
 * SearchComponent
 * Reusable search input with keyboard shortcut support (Ctrl+K)
 */

import { useEffect, useRef, useState } from 'react';
import { Button, Input } from 'antd';
import { IconSearch } from './icons';
import { useTranslation } from 'react-i18next';

const { Search } = Input;

const SearchComponent = ({ placeholder, handleSearch, loading }) => {
  const { t } = useTranslation();
  const searchRef = useRef(null);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        if (searchRef.current) {
          searchRef.current.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const onSearch = (value) => {
    handleSearch(value);
    setSearchValue(value);
  };

  const onClear = () => {
    setSearchValue('');
    handleSearch('');
  };

  return (
    <Search
      ref={searchRef}
      placeholder={placeholder || t('common.search')}
      onSearch={onSearch}
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      enterButton={
        <Button type="primary" icon={<IconSearch />} loading={loading}>
          {t('common.search')}
        </Button>
      }
      allowClear
      onClear={onClear}
      size="middle"
    />
  );
};

export default SearchComponent;

